// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PhTeM","imagem":"styles_imagem__NSdY8","button":"styles_button__wqDH6"};